import api from './api'

export default {
  findAll () {
    return api.get('/users')
  },
  findOne (id) {
    return api.get('/users/' + id)
  },
  create (data) {
    return api.post('/users', data)
  },
  edit (id, data) {
    return api.put('/users/' + id, data)
  },
  deleteUser (id) {
    return api.delete('/users/' + id)
  },
  block (id) {
    return api.delete('/users-safe/' + id)
  }
}
